import { render, staticRenderFns } from "./EditForms.vue?vue&type=template&id=7ff39dce&scoped=true&"
import script from "./EditForms.vue?vue&type=script&lang=js&"
export * from "./EditForms.vue?vue&type=script&lang=js&"
import style0 from "./EditForms.vue?vue&type=style&index=0&id=7ff39dce&scoped=true&lang=scss&"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff39dce",
  null
  
)

export default component.exports